import React, { useState } from 'react';

export default function TestDriveForm({ onClose }) {
    const [formData, setFormData] = useState({
        email: '',
        nom: '',
        prenom: '',
        telephone: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            // Utiliser l'URL complète en dev, relative en production
            const apiUrl = process.env.NODE_ENV === 'production'
                ? '/api/test-drive'
                : 'http://localhost:5000/api/test-drive';

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (response.ok) {
                setSubmitStatus('success');
                // Reset form after 2 seconds and close modal
                setTimeout(() => {
                    setFormData({
                        email: '',
                        nom: '',
                        prenom: '',
                        telephone: ''
                    });
                    onClose();
                }, 2000);
            } else {
                setSubmitStatus('error');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="test-drive-modal" onClick={onClose}>
            <div className="test-drive-modal__content" onClick={(e) => e.stopPropagation()}>
                <button className="test-drive-modal__close" onClick={onClose}>×</button>
                
                <h2>Demande d'essai A390</h2>
                
                {submitStatus === 'success' && (
                    <div className="test-drive-modal__success">
                        <p>Votre demande a été envoyée avec succès !</p>
                    </div>
                )}

                {submitStatus === 'error' && (
                    <div className="test-drive-modal__error">
                        <p>Une erreur est survenue. Veuillez réessayer.</p>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="test-drive-form">
                    <div className="test-drive-form__group">
                        <label htmlFor="email">Email *</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="test-drive-form__group">
                        <label htmlFor="nom">Nom *</label>
                        <input
                            type="text"
                            id="nom"
                            name="nom"
                            value={formData.nom}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="test-drive-form__group">
                        <label htmlFor="prenom">Prénom *</label>
                        <input
                            type="text"
                            id="prenom"
                            name="prenom"
                            value={formData.prenom}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="test-drive-form__group">
                        <label htmlFor="telephone">Numéro de téléphone *</label>
                        <input
                            type="tel"
                            id="telephone"
                            name="telephone"
                            value={formData.telephone}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="test-drive-form__actions">
                        <button 
                            type="button" 
                            className="test-drive-form__cancel"
                            onClick={onClose}
                            disabled={isSubmitting}
                        >
                            Annuler
                        </button>
                        <button 
                            type="submit" 
                            className="test-drive-form__submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Envoi...' : 'Envoyer'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

